import React from 'react';

import AppleIcon from './Apple';
import FacebookIcon from './Facebook';
import InstagramIcon from './Instagram';
import SpotifyIcon from './Spotify';
import TwitterIcon from './Twitter';
import YouTubeIcon from './YouTube';

const Icons = {
    facebook: FacebookIcon,
    instagram: InstagramIcon,
    twitter: TwitterIcon,
    youtube: YouTubeIcon,
    spotify: SpotifyIcon,
    apple: AppleIcon,
};

type IconLabel = keyof typeof Icons;

// Brand names used as the accessible name of icon-only links
const Names: Record<IconLabel, string> = {
    facebook: 'Facebook',
    instagram: 'Instagram',
    twitter: 'X (Twitter)',
    youtube: 'YouTube',
    spotify: 'Spotify',
    apple: 'Apple Podcasts',
};

interface IconItem {
    label: IconLabel;
    [key: string]: unknown;
}

export const addIcons = <T extends IconItem>(
    items: T[],
    props: Record<string, unknown>,
): Array<Omit<T, 'label'> & { label: React.ReactElement | null; ariaLabel: string | null }> =>
    (items || []).map(({ label, ...it }) => {
        const Icon = Icons[label] || null;
        return {
            ...it,
            label: Icon !== null ? <Icon {...props} /> : null,
            ariaLabel: Icon !== null ? Names[label] : null,
        } as Omit<T, 'label'> & { label: React.ReactElement | null; ariaLabel: string | null };
    });

export default Icons;
